// extracted by mini-css-extract-plugin
export default {"tableContainer":"Delete_tableContainer__6th2G","deleteTable":"Delete_deleteTable__f8Gu4"};